<script setup lang="ts">
defineProps<{
  isLoading: boolean
  noResults: boolean
  noMoreResults: boolean
  loadingMessage: string
}>()
</script>

<template>
  <div>
    <!-- Loading spinner -->
    <div v-if="isLoading" class="py-m text-center">
      <div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      <p class="mt-xs text-caption">
        {{ loadingMessage }}
      </p>
    </div>

    <!-- No more results message -->
    <div v-else-if="noMoreResults" class="py-m text-center text-caption">
      Ingen flere sider å laste
    </div>

    <!-- No results message -->
    <div v-else-if="noResults" class="py-xl text-center text-caption italic">
      Ingen sider funnet
    </div>
  </div>
</template>
